import { render, staticRenderFns } from "./OrbitStrategyActionModal.vue?vue&type=template&id=f49900be&scoped=true"
import script from "./OrbitStrategyActionModal.vue?vue&type=script&lang=js"
export * from "./OrbitStrategyActionModal.vue?vue&type=script&lang=js"
import style0 from "./OrbitStrategyActionModal.vue?vue&type=style&index=0&id=f49900be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49900be",
  null
  
)

export default component.exports